var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFacebookSquare = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.643 0H2.357A2.357 2.357 0 000 2.357v17.286A2.357 2.357 0 002.357 22h6.74v-7.48H6.003V11h3.094V8.317c0-3.052 1.817-4.738 4.6-4.738 1.333 0 2.726.238 2.726.238v2.995h-1.535c-1.513 0-1.985.94-1.985 1.902V11h3.377l-.54 3.52h-2.837V22h6.74A2.357 2.357 0 0022 19.643V2.357A2.357 2.357 0 0019.643 0z",
    fill: "#000",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebookSquare, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/facebook-square.cc55cbb8.svg";
export { ForwardRef as ReactComponent };